let React            = require("react");
let PackageCard      = require("./PackageCard.jsx");
let Model3DCard      = require("./Model3DCard.jsx");
let AssetCard        = require("./generic/AssetCard.jsx");
let RestoreButton    = require("../buttons/RestoreButton.jsx");
let CircuitsUtil     = require("../../util/CircuitsUtil.js");
let AssetDetailsLink = require("../buttons/AssetDetailsLink.jsx");

class TrashCard extends React.Component {

     render() {
        let Buttons = this.props.hubDeleted? null: { all:[RestoreButton] }

        let objUrl = {};
        const { type, id, name, save_points } = this.props.resource;

        if(type === "library"){
            objUrl = { pathname: CircuitsUtil.getViewUrl("libraries", id, name), state: { modal: true, previousView: location.pathname }}
        }

        return <React.Fragment>
            { type == "library" &&
                <AssetCard {...this.props} 
                    noThumbnail
                    urlName="libraries"
                    cssCardTag="library"
                    loginRequired
                    thumbnailUseResource
                    Buttons={Buttons} 
                    Action = {CircuitsUtil.getStatusLibrary(save_points) !== "failed"? props => <AssetDetailsLink {...props} objUrl={objUrl}/>:
                                                                                        props => <props.Content noLink={true}/>} />}

            { type == "package" &&
                <PackageCard {...this.props} 
                    switchThumbnail={true}
                    thumbnailUseResource
                    Buttons={Buttons}/> }

            { type == "3dmodel" &&
                <Model3DCard {...this.props} 
                    thumbnailUseResource
                    Buttons={Buttons}/> }
                    
        </React.Fragment>
    }
}

module.exports = TrashCard;
